// extracted by mini-css-extract-plugin
module.exports = {"trophyMemoryCardList__container":"TrophyMemoryCardList_trophy-memory-card-list__container__dPfGl"};